import { Input } from "./layer/wrapper";
import { Tabs, Tab } from "./layer/wrapper";
import { IconDashboard, IconList } from "./layer/wrapper";
import { WrapperCard, Button, Card, Wrapper } from "./layer/wrapper";
import ContainerContent from "../Container/ContainerContent";
import React, { useEffect, useMemo, useState } from "react";
import { getCurrentLocalDateTime } from "../../utils/getLocalDateTime";
import { API, Auth, Storage } from "aws-amplify";
import { Radio } from "./layer/wrapper";
import _ from "lodash";
import ExportBuro from "./excel/exportBuro";
import ExportFirstYearBuro from "./excel/exportFirstYearBuro";
// import { UpdateBuro } from "./layer/updateBuro";
import HistoryFile from "./layer/historyFile";
import {
  reinstallments,
  calcuratorInterestTwo,
} from "../../utils/reinstallments";
import LoadingPage from "../Loading/LoadingPage";
import LetterBuro from "./layer/letterBuro";
import FilterEmail, { optionsEmail } from "./layer/filterEmail";
import SendEmail from "./layer/sendEmail";
import Envelope from "./layer/envelope";
import ReportBotPLO from "./layer/reportBotPLO";
import ReportBotPLC from "./layer/reportBotPLC";
// import Aging from "./layer/agingThree";
import LastPaymentDone from "./layer/lastPaymentDone";
import ReportNCB from "./excel/exportReportNCB";
import ExportPLC from "./excel/exportPLC";
import ExportPLO from "./excel/exportPLO";
import { pad } from "../../utils/getLocalDateTime";
import { useSelector } from "react-redux";
import { CardBuroBan } from "./layer/wrapper";
import ExportBuroSelected from "./excel/exportLastPaymentDone";
import Select from "react-select";
import { pdf, PDFViewer } from "@react-pdf/renderer";
import PdfBuroYear from "../PdfViewer/PdfBuroYear";
import PDFMerger from "pdf-merger-js/browser";
import { format } from "date-fns";
import Minizip from "minizip-asm.js";
import classNames from "classnames";
import fixedBuro10 from "./fixedBuro10";
import fixedBuro11, { buro11 } from "./fixedBuro11";
import ExportFixedBuro from "./excel/exportFixedBuro";
import { EmitterStatus } from "event";
import fixedBuro042024 from "./fixedBuro042024";
import fixedBuro042024Debt from "./fixedBuro042024Debt";
import { DatePicker } from "antd";
import moment from "moment";
import { getBuroMonthEndDate } from "./buroMonth";

const legacyBankrupt = [
  "400153739",
  "400161566",
  "400130674",
  "400125134",
  "400122538",
  "400017387",
  "400199836",
  "400157570",
];

export const getFilterLoanBuro = (
  loans = [],
  buroDate,
  interest,
  fixedDone = false
) => {
  let filterLoan = loans
    ?.map((loan) => {
      // console.log("loan", loan.loan_kbank_id)
      // if (loan.loan_kbank_id === "400049697") {
      //   return { ...loan, checked: true };
      // }

      const newLoan = reinstallments(loan, new Date(buroDate), interest);

      const calNewLoan = calcuratorInterestTwo(
        { ...loan, ...newLoan },
        {
          where: { paid_date: new Date(buroDate) },
          dataInterest: interest,
        }
      );

      const loanInterest = interest?.Items?.find(
        (it) => it.type === loan.interest_type
      );

      const includeLoan = {
        ...newLoan,
        ...calNewLoan,
        loanInterest,
        original: loan,
      };

      if (fixedDone) {
        return includeLoan;
      }

      // if (loan.loan_kbank_id === "400046167") {
      //   console.log("hello", includeLoan);
      // }

      let check = false;
      let checkRecap = false;
      if (includeLoan?.evidence?.length > 0) {
        const lastEvidencePaidDate =
          includeLoan?.evidence[includeLoan?.evidence.length - 1].paid_date;
        let lastEvidencePaidDateFullDate = getCurrentLocalDateTime(
          new Date(lastEvidencePaidDate)
        ).fullDate;

        let buroFullDateMin = new Date(buroDate);
        buroFullDateMin.setDate(1);
        let buroFullDateMax = getCurrentLocalDateTime(
          new Date(buroDate)
        ).fullDate;

        let buroDateMinFullDate = getCurrentLocalDateTime(
          new Date(buroFullDateMin)
        ).fullDate;

        if (
          lastEvidencePaidDateFullDate <= "2022-03-01" &&
          loan.loan_status === "DONE" &&
          includeLoan.loan_status === "ACTIVE"
        ) {
          check = true;
        }

        if (
          lastEvidencePaidDateFullDate >= buroDateMinFullDate &&
          lastEvidencePaidDateFullDate <= buroFullDateMax &&
          loan.loan_status === "DONE"
        ) {
          checkRecap = true;
        }
      }

      if (
        (includeLoan.loan_status === "ACTIVE" ||
          includeLoan.loan_status === "FAIL") &&
        !check &&
        !checkRecap &&
        !legacyBankrupt.includes(loan?.loan_kbank_id)
      ) {
        return { ...includeLoan, checked: true };
      }
    })
    .filter((item) => item);
  return filterLoan;
};

const Aging = ({
  setLoan,
  setOriLoan,
  loan = [],
  agingDate = new Date(),
  buroDate = new Date(),
  setIsSelectAll,
  setCount,
  count,
  setDisabledAging,
  disabledAging,
  setDisabledLastPayment,
  setLoanNotCal,
  dateRequestTime,
}) => {
  const [localCount, setLocalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const getLastItem = (lastItem) => {
    let lastItemStr = "";
    if (lastItem) {
      const lastItemKeys = Object.keys(lastItem);
      lastItemKeys.forEach((key) => {
        lastItemStr += `${key}=${lastItem[key]}&`;
      });
    }
    return lastItemStr;
  };

  const onClickAging = async () => {
    try {
      setLoading(true);
      setDisabledAging(true);
      setDisabledLastPayment(true);

      let data = {};
      let localCountFunc = 0;
      let lastItem = null;
      let keepLoan = [];
      let loanNotCal = [];

      const dataResponse = await await API.get("MoneyHubAdmin", "/interest", {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });

      const interest = JSON.parse(dataResponse.body);

      const selectMonth = new Date(agingDate);
      let today = new Date(agingDate);
      let lastDate = today.getDate();
      let paid_date = new Date();

      // if (selectMonth.getMonth() === today.getMonth()) {
      //   paid_date = `${selectMonth.getFullYear()}-${pad(
      //     selectMonth.getMonth() + 1
      //   )}-${pad(today.getDate())}`;
      // } else {
      //   const newToday = new Date(
      //     selectMonth.getFullYear(),
      //     selectMonth.getMonth() + 1,
      //     0
      //   );
      //   lastDate = newToday.getDate();
      //   paid_date = `${selectMonth.getFullYear()}-${pad(
      //     selectMonth.getMonth() + 1
      //   )}-${pad(newToday.getDate())}`;
      // }

      do {
        data = await API.get("MoneyHubAdmin", "/loan/sandbox/agingReport", {
          queryStringParameters: {
            paid_date: dateRequestTime.max,
            min_date: dateRequestTime.min,
            ExclusiveStartKey: getLastItem(lastItem),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = data?.lastItem;

        let filterLoan = data?.Items?.map((item) => {
          // const newLoan = reinstallments(item, new Date(buroDate), interest);

          let newLoan = {};
          if (
            item.loan_status === "DONE"
            // item.loan_kbank_id !== "400069709"
          ) {
            let lastEvidence = item.evidence[item.evidence.length - 1];
            let lastPaidDate = getCurrentLocalDateTime(
              new Date(lastEvidence.paid_date)
            );
            if (
              lastPaidDate.fullDate > getCurrentLocalDateTime(buroDate).fullDate
            ) {
              newLoan = reinstallments(item, new Date(buroDate), interest);
            }
          }

          if (["400181853"].includes(item?.loan_kbank_id)) {
            newLoan = reinstallments(item, new Date(buroDate), interest);
          }

          let calNewLoan = calcuratorInterestTwo(
            { ...item, ...newLoan },
            {
              where: { paid_date: new Date(buroDate) },
              dataInterest: interest,
            }
          );

          const loanInterest = interest?.Items?.find(
            (it) => it.type === item.type
          );

          // if (item.loan_kbank_id === "400069709") {
          //   calNewLoan.loan_status = "ACTIVE"
          // }

          const includeLoan = {
            ...newLoan,
            ...calNewLoan,
            loanInterest,
            original: item,
            checked: true,
          };

          return includeLoan;
        });

        localCountFunc += filterLoan?.length;
        keepLoan.push(...filterLoan);
        setLocalCount(localCountFunc);
      } while (lastItem);

      setOriLoan(_.cloneDeep(keepLoan));
      setLoan(_.cloneDeep(keepLoan));
      setLoanNotCal(_.cloneDeep(loanNotCal));
      setCount(keepLoan.length);
      setIsSelectAll(true);
    } catch (error) {
      console.log("loading error", error);
    } finally {
      setLoading(false);
      setDisabledAging(false);
      setDisabledLastPayment(false);
    }
  };

  return (
    <div className="flex space-x-2 w-full">
      <Button loading={loading} disabled={disabledAging} onClick={onClickAging}>
        {localCount > 0 && localCount} ยืนยัน
      </Button>
    </div>
  );
};

export const BuroMainTwo = () => {
  const limit = 100;

  const today = getCurrentLocalDateTime(new Date());
  const { user } = useSelector((state) => state.initializeApp);

  const [loadingGenFile, setLoadingGenFile] = useState();

  const defaultMin = getCurrentLocalDateTime(new Date("2021-10-05")).fullDate;
  const defaultMax = getCurrentLocalDateTime(new Date()).fullDate;

  const defaultAgingDate = getCurrentLocalDateTime().fullDate;

  const [buroDate, setBuroDate] = useState(
    getBuroMonthEndDate(moment(today.fullDate, "YYYY-MM-DD", true))
  );
  const [dateRequestTime, setDateRequestTime] = useState({
    min: defaultMin,
    max: defaultMax,
  });

  const [loanLastPaymentDone, setLoanLastPaymentDone] = useState([]);
  const [loadingInterest, setLoadingInterest] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [searched, setSearched] = useState("");
  const [radioBuroStatus, setRadioBuroStatus] = useState("ALL");
  const [skip, setSkip] = useState(limit);
  const [count, setCount] = useState(0);
  const [countSingle, setCountSingle] = useState(0);
  const [tab, setTab] = useState("M");
  const [loan, setLoan] = useState([]);
  const [loanNotCal, setLoanNotCal] = useState([]);
  const [oriLoan, setOriLoan] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(true);
  const [isSingleSelectAll, setIsSingleSelectAll] = useState(true);
  const [interest, setInterest] = useState();
  const [manageStatus, setManageStatus] = useState("M");
  const [loadingSingle, setLoadingSingle] = useState(false);
  const [agingDate, setAgingDate] = useState(defaultAgingDate);
  const [oriSingleLoad, setOriSingleLoad] = useState([]);
  const [singleLoad, setSingleLoad] = useState([]);
  const [loan_kbank_id, setLoan_kbank_id] = useState("");
  const [loadingBuroBan, setLoadingBuroBan] = useState(false);
  const [disabledAging, setDisabledAging] = useState(false);
  const [disabledLastPayment, setDisabledLastPayment] = useState(false);
  const [loadingQueryBuroBan, setLoadingQueryBuroBan] = useState(false);
  const [buroBan, setBuroBan] = useState([]);
  const [notFound, setNotFound] = useState("");
  const [selectOption, setSelectOption] = useState({
    label: "ทั้งหมด",
    value: "ALL",
  });
  const [countEmail, setCountEmail] = useState(0);
  const [countLetter, setCountLetter] = useState(0);
  const [buroYearItems, setBuroYearItems] = useState([]);
  const [buroFilter, setBuroFilter] = useState();
  const [buroYear, setBuroYear] = useState({ label: 2024, value: 2024 });
  const [countBuroYear, setCountBuroYear] = useState(0);
  const [loadingBuroYear, setLoadingBuroYear] = useState(false);
  const [loadingLetter, setLoadingLetter] = useState(false);
  const [errorBuroYear, setErrorBuroYear] = useState("");
  // const [jobNo, setJobNo] = useState("400049081");
  const [jobNo, setJobNo] = useState("400141164");
  // const [jobNo, setJobNo] = useState("L0935565545_221164_1131_2");
  // const [jobNo, setJobNo] = useState("L0626596698_141064_1346_1");
  const [loadingEmail, setLoadingEmail] = useState(false);

  const [radioFieldName, setRadioFieldName] = useState("loan_kbank_id");
  const [s3Status, setS3Status] = useState("");
  const [buroYearChunckItems, setBuroYearChunckItems] = useState([]);
  const [chunckActiveIndex, setChunckActiveIndex] = useState(-1);
  const [selectYearFilter, setSelectYearFilter] = useState({
    label: "ส่งจดหมาย",
    value: "2",
  });
  const [monthYear, setMonthYear] = useState(`2021-11`);
  const [year, setYear] = useState({ label: 2021, value: 2021 });
  const [fixedBuro, setFixedBuro] = useState([]);
  const [loadingFixedBuro, setLoadingFixedBuro] = useState(false);
  const [defaultBuro, setDefaultBuro] = useState([]);
  const [minMonthYear, setMinMonthYear] = useState("2021-10");

  const countLength = 300;

  useEffect(() => {
    fetchInterest();
    fetchBuroBan();
    fetchS3Status();
  }, []);

  const fetchS3Status = async () => {
    try {
      const s3Status = await Storage.get(`รหัสและสถานะบัญชี.pdf`);
      // setS3Status(await getBase64FromUrl(s3Status));
      setS3Status(s3Status);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      };
    });
  };

  const fetchInterest = async () => {
    try {
      setLoadingInterest(true);
      const data = await API.get("MoneyHubAdmin", "/interest");
      const parseData = JSON.parse(data.body);
      setInterest(parseData);
    } catch (error) {
      console.log("fetch interest error", error);
    } finally {
      setLoadingInterest(false);
    }
  };

  const getLastItem = (lastItem) => {
    let lastItemStr = "";
    if (lastItem) {
      const lastItemKeys = Object.keys(lastItem);
      lastItemKeys.forEach((key) => {
        lastItemStr += `${key}=${lastItem[key]}&`;
      });
    }
    return lastItemStr;
  };

  const prePareLoanNotCal = (loans = []) => {
    const newLoans = loans
      .map((loan) => {
        const loanInterest = interest?.Items?.find(
          (it) => it.type === loan.interest_type
        );

        if (loan.loan_status === "ACTIVE") {
          return {
            ...loan,
            original: loan,
            loanInterest,
            checked: loan?.checked ? loan?.checked : true,
          };
        }
      })
      .filter((loan) => loan);
    return newLoans;
  };

  const prePareLoanSingle = (loans = []) => {
    const newLoans = loans.map((item) => {
      let newLoan = {};
      if (item.loan_status === "DONE") {
        let lastEvidence = item.evidence[item.evidence.length - 1];
        let lastPaidDate = getCurrentLocalDateTime(
          new Date(lastEvidence.paid_date)
        );
        if (
          lastPaidDate.month < getCurrentLocalDateTime(buroDate).month &&
          lastPaidDate.year <= getCurrentLocalDateTime(buroDate).year
        ) {
          newLoan = reinstallments(item, new Date(buroDate), interest);
        }
      }

      // newLoan = reinstallments(item, new Date(buroDate), interest);

      const calNewLoan = calcuratorInterestTwo(
        { ...item, ...newLoan },
        {
          where: { paid_date: new Date(buroDate) },
          dataInterest: interest,
        }
      );

      const loanInterest = interest?.Items?.find((it) => it.type === item.type);

      const includeLoan = {
        ...newLoan,
        ...calNewLoan,
        loanInterest,
        original: item,
        checked: item?.checked ? item?.checked : true,
      };

      return includeLoan;
    });
    return newLoans;
  };

  const prePareLoan = (loans = [], referenceDate = buroDate) => {
    const newLoans = loans.map((item) => {
      let newLoan = {};
      // if (item.loan_status === "DONE") {
      //   let lastEvidence = item.evidence[item.evidence.length - 1];
      //   let lastPaidDate = getCurrentLocalDateTime(
      //     new Date(lastEvidence.paid_date)
      //   );
      //   if (
      //     lastPaidDate.fullDate > getCurrentLocalDateTime(buroDate).fullDate
      //   ) {
      //     newLoan = reinstallments(item, new Date(buroDate), interest);
      //   }
      // }

      newLoan = reinstallments(item, new Date(referenceDate), interest);

      const calNewLoan = calcuratorInterestTwo(
        { ...item, ...newLoan },
        {
          where: { paid_date: new Date(referenceDate) },
          dataInterest: interest,
        }
      );

      const loanInterest = interest?.Items?.find((it) => it.type === item.type);

      const includeLoan = {
        ...newLoan,
        ...calNewLoan,
        loanInterest,
        original: item,
        checked: item?.checked ? item?.checked : true,
      };

      return includeLoan;

      // return {
      //   ...loan,
      //   original: loan,
      //   checked: loan?.checked ? loan?.checked : true,
      // };
    });

    // const newLoans = loans
    //   // .filter((loan) => loan.loan_status === "ACTIVE")
    //   .map((loan) => {
    //     // const newLoan = reinstallments(loan, new Date(buroDate), interest);

    //     // const calNewLoan = calcuratorInterestTwo(
    //     //   { ...loan },
    //     //   {
    //     //     where: { paid_date: new Date(buroDate) },
    //     //     dataInterest: interest,
    //     //   }
    //     // );

    //     const loanInterest = interest?.Items?.find(
    //       (it) => it.type === loan.interest_type
    //     );

    //     const includeLoan = {
    //       // ...newLoan,
    //       ...loan,
    //       loanInterest,
    //       original: loan,
    //     };

    //     let check = false;
    //     let checkRecap = false;
    //     if (includeLoan?.evidence?.length > 0) {
    //       const lastEvidencePaidDate =
    //         includeLoan?.evidence[includeLoan?.evidence.length - 1].paid_date;
    //       let lastEvidencePaidDateFullDate = getCurrentLocalDateTime(
    //         new Date(lastEvidencePaidDate)
    //       ).fullDate;

    //       let buroFullDateMin = new Date(buroDate);
    //       buroFullDateMin.setDate(1);
    //       let buroFullDateMax = getCurrentLocalDateTime(
    //         new Date(buroDate)
    //       ).fullDate;

    //       if (
    //         lastEvidencePaidDateFullDate <= "2022-03-01" &&
    //         loan.loan_status === "DONE" &&
    //         includeLoan.loan_status === "ACTIVE"
    //       ) {
    //         check = true;
    //       }

    //       let buroDateMinFullDate = getCurrentLocalDateTime(
    //         new Date(buroFullDateMin)
    //       ).fullDate;

    //       if (
    //         lastEvidencePaidDateFullDate >= buroDateMinFullDate &&
    //         lastEvidencePaidDateFullDate <= buroFullDateMax &&
    //         // includeLoan.loan_status === "ACTIVE" &&
    //         loan.loan_status === "DONE"
    //       ) {
    //         checkRecap = true;
    //       }
    //     }

    //     if (
    //       // (includeLoan.loan_status === "ACTIVE" ||
    //       //   includeLoan.loan_status === "FAIL") &&
    //       !check &&
    //       !checkRecap &&
    //       !legacyBankrupt.includes(loan?.loan_kbank_id)
    //     ) {
    //       return {
    //         ...includeLoan,
    //         original: loan,
    //         loanInterest,
    //         checked: loan?.checked ? loan?.checked : true,
    //       };
    //     }
    //   })
    //   .filter((loan) => loan);
    return newLoans;
  };

  const onClickGenFile = async () => {
    try {
      setLoadingGenFile(true);
      setOriLoan([]);
      setLoan([]);

      let data = {};
      let localCount = 0;
      let lastItem = null;
      let keepLoan = [];

      do {
        data = await API.get("MoneyHubAdmin", "/buro", {
          queryStringParameters: {
            ...dateRequestTime,
            buro_status: "PENDING",
            ExclusiveStartKey: getLastItem(lastItem),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = data?.lastItem;
        localCount += data?.loan.length;
        setCount(localCount);
        keepLoan.push(...data.loan);
      } while (lastItem);

      // const newInstallments = reinstallments(
      //   loan,
      //   new Date(buroDate),
      //   interest
      // );
      // const newLoan = calcuratorInterestTwo(
      //   { ...loan, ...newInstallments },
      //   { where: { paid_date: buroDate }, dataInterest: interest }
      // );

      // keepLoan = keepLoan.filter((loan) => {
      //   const evidence = loan.evidence;

      //   const newInstallments = reinstallments(
      //     loan,
      //     new Date(buroDate),
      //     interest
      //   );

      //   const newLoan = calcuratorInterestTwo(
      //     { ...loan, ...newInstallments },
      //     { where: { paid_date: buroDate }, dataInterest: interest }
      //   );

      //   const includeLoan = { ...newInstallments, ...newLoan };
      //   for (let index = 0; index < evidence.length; index++) {
      //     const ev = evidence[index];
      //     const findIndexPaidDate = ev.findIndex(
      //       (item) => item.paid_date <= "2022-03-01T23:59:59+07:00"
      //     );
      //     if (findIndexPaidDate !== -1) {
      //       console.log("findIndexPaidDate", findIndexPaidDate);
      //       // includeLoan.evidence = ev
      //       break;
      //     }
      //   }
      //   // if(loan.loan_status === "DONE" && )
      // });

      setOriLoan(_.cloneDeep(prePareLoan(keepLoan)));
      setLoan(_.cloneDeep(prePareLoan(keepLoan)));
      setLoanNotCal(_.cloneDeep(prePareLoanNotCal(keepLoan)));
      setCount(keepLoan.length);
      setIsSelectAll(true);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingGenFile(false);
    }
  };

  const onChangeRequestTime = (e) => {
    const { name, value } = e.target;

    setDateRequestTime((prev) => ({ ...prev, [name]: value }));
  };

  const onChangeBuroMonth = (date) => {
    const nextBuroDate = getBuroMonthEndDate(date);
    if (!nextBuroDate) {
      return;
    }

    setBuroDate(nextBuroDate);
    if (manageStatus === "M") {
      setOriLoan(prePareLoan(oriLoan, nextBuroDate));
      setLoan(prePareLoan(loan, nextBuroDate));
    } else {
      setOriSingleLoad(prePareLoan(oriSingleLoad, nextBuroDate));
      setSingleLoad(prePareLoan(singleLoad, nextBuroDate));
    }
  };

  const onChangeBuroYearMonth = (date) => {
    if (!getBuroMonthEndDate(date)) {
      return;
    }

    setMonthYear(date.format("YYYY-MM"));
  };

  const onClickSkip = () => {
    setLoadingMore(true);
    setTimeout(() => {
      setSkip((prev) => prev + limit);
      setLoadingMore(false);
    }, 800);
  };

  const onChangeSearch = (e) => {
    const { value } = e.target;

    const filterLoan = oriLoan.filter((item) => {
      return (
        String(item.loan_kbank_id)
          .toLocaleLowerCase()
          .includes(value.toLocaleLowerCase()) ||
        String(item.fullname)
          .toLocaleLowerCase()
          .includes(value.toLocaleLowerCase())
      );
    });
    setLoan(filterLoan);
    setSearched(value);
  };

  const onChangeSearchSingle = (e) => {
    const { value } = e.target;
    setSearched(value);
  };

  const returnMapAllChecked = (data = [], checked) => {
    return data.map((item) => {
      return {
        ...item,
        checked: checked,
      };
    });
  };

  const onClickUnSelectAll = () => {
    setLoan((prev) => returnMapAllChecked(prev, false));
    setOriLoan((prev) => returnMapAllChecked(prev, false));
    setIsSelectAll(false);
  };

  const onClickSelectAll = () => {
    setLoan((prev) => returnMapAllChecked(prev, true));
    setOriLoan((prev) => returnMapAllChecked(prev, true));
    setIsSelectAll(true);
  };

  const onClickSingleUnSelectAll = () => {
    setSingleLoad((prev) => returnMapAllChecked(prev, false));
    setOriSingleLoad((prev) => returnMapAllChecked(prev, false));
    setIsSingleSelectAll(false);
  };

  const onClickSingleSelectAll = () => {
    setSingleLoad((prev) => returnMapAllChecked(prev, true));
    setOriSingleLoad((prev) => returnMapAllChecked(prev, true));
    setIsSingleSelectAll(true);
  };

  const returnMapSingleLoad = (data = [], loan) => {
    const checkExist = data.find(
      (item) => item.loan_kbank_id === loan.loan_kbank_id
    );
    if (!checkExist) {
      data.push(loan);
    }
    return data;
  };

  const onClickLoadSingle = async () => {
    try {
      setLoadingSingle(true);

      // console.log("listLoan", listLoan.length);

      // for (const loan of listLoan) {
      const data = await API.get("MoneyHubAdmin", "/buro/single", {
        queryStringParameters: {
          field_name: radioFieldName,
          value: searched,
        },
      });

      const mapSingleLoad = returnMapSingleLoad(singleLoad, data.loan);
      const mapOriSingleLoad = returnMapSingleLoad(singleLoad, data.loan);

      setOriSingleLoad(_.cloneDeep(prePareLoanSingle(mapOriSingleLoad)));
      setSingleLoad(_.cloneDeep(prePareLoanSingle(mapSingleLoad)));
      setLoanNotCal(_.cloneDeep(prePareLoanNotCal(mapSingleLoad)));
      setCountSingle((prev) => {
        return prev + 1;
      });
      setSearched("");
      setIsSingleSelectAll(true);
      // }
    } catch (error) {
      console.log("load single error", error);
    } finally {
      setLoadingSingle(false);
    }
  };

  const onClickToday = () => {
    setDateRequestTime((prev) => {
      return {
        min: getCurrentLocalDateTime(new Date()).fullDate,
        max: getCurrentLocalDateTime(new Date()).fullDate,
      };
    });
  };

  const onClickMonth = () => {
    const today = new Date();
    setDateRequestTime((prev) => {
      return {
        min: getCurrentLocalDateTime(
          new Date(today.getFullYear(), today.getMonth(), 1)
        ).fullDate,
        max: getCurrentLocalDateTime(
          new Date(today.getFullYear(), today.getMonth() + 1, 0)
        ).fullDate,
      };
    });
  };

  const onClickStartToday = () => {
    setDateRequestTime({ min: defaultMin, max: defaultMax });
  };

  const onChangeManageStatus = (e) => {
    const { value } = e.target;
    setManageStatus(value);
  };

  const onChangeRadioFieldName = (e) => {
    const { value } = e.target;
    setRadioFieldName(value);
  };

  const onChangeAgingDate = (e) => {
    const { value } = e.target;
    setAgingDate(value);
  };

  const fetchBuroBan = async () => {
    try {
      setLoadingQueryBuroBan(true);
      const data = await API.get("MoneyHubAdmin", "/buro/queryBuroBan", {
        queryStringParameters: {
          loan_kbank_id,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      setBuroBan(data.items);
    } catch (error) {
      console.log("fetch error", error);
    } finally {
      setLoadingQueryBuroBan(false);
    }
  };

  const onClickBuroBan = async () => {
    try {
      setLoadingBuroBan(true);
      const findLoanExist = await API.get(
        "MoneyHubAdmin",
        "/buro/findLoanExist",
        {
          queryStringParameters: {
            loan_kbank_id,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      if (findLoanExist.item !== null) {
        setNotFound(false);
        await API.post("MoneyHubAdmin", "/buro/createBuroBan", {
          body: {
            loan_kbank_id,
            username: user.username,
            fullname: findLoanExist.item.fullname,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        await fetchBuroBan();
        setLoan_kbank_id("");
      } else {
        setNotFound(true);
      }
    } catch (error) {
      console.log("buro ban", error);
    } finally {
      setLoadingBuroBan(false);
    }
  };

  const oriLoanChecked = useMemo(
    () =>
      oriLoan?.filter((item) => {
        if (selectOption.value !== "ALL") {
          return item.checked && item.letter === selectOption.value;
        }
        return item.checked;
      }),
    [oriLoan, selectOption]
  );

  const oriSingleLoanChecked = useMemo(
    () => oriSingleLoad?.filter((itemLoan) => itemLoan.checked),
    [oriSingleLoad]
  );

  const getYears = () => {
    const today = new Date();
    const year = today.getFullYear();
    const years = [{ label: year, value: year }];
    const minYear = 2021;
    for (let index = minYear; index < year; index++) {
      years.push({ label: index, value: index });
    }
    return years.sort((a, b) => b.value - a.value);
  };

  const getChunckItems = (allItems = [], countLength = 300) => {
    const countChunck = Math.ceil(allItems.length / countLength);
    const newAllItems = new Array(countChunck);
    for (let i = 0; i < countChunck; i++) {
      const start = i * countLength;
      const end = i * countLength + countLength;
      newAllItems[i] = allItems.slice(start, end);
    }
    return newAllItems;
  };

  const onClickChunckItem = (index) => {
    setChunckActiveIndex(index);
  };

  const mapBuroYear = (allItems) => {
    let newMapBuroYearDone = [];
    const newMapBuroYear = [...allItems]
      .map((item) => {
        let sameObj = {
          ...item,
          job_no: item?.loan_kbank_id,
          letter: item?.letter === "" ? "2" : item?.letter,
        };

        // if (
        //   item.loan_status === "DONE"
        //   // item.loan_kbank_id !== "400069709"
        // ) {
        //   let lastEvidence = item.evidence[item.evidence.length - 1];
        //   let lastPaidDate = getCurrentLocalDateTime(
        //     new Date(lastEvidence.paid_date)
        //   );
        //   if (
        //     lastPaidDate.fullDate > getCurrentLocalDateTime(buroDate).fullDate
        //   ) {
        //     sameObj = reinstallments(item, new Date(buroDate), interest);
        //   }
        // }

        // const calNewLoan = calcuratorInterestTwo(
        //   { ...item, ...sameObj },
        //   {
        //     where: { paid_date: buroDate },
        //     dataInterest: interest,
        //   }
        // );

        // const loanInterest = interest?.Items?.find(
        //   (it) => it.type === item.type
        // );

        sameObj = {
          ...sameObj,
          // ...calNewLoan,
          // loanInterest,
          original: item,
          checked: true,
        };

        // return sameObj;

        // // if (!item?.evidence?.length) {
        // //   return sameObj;
        // // }

        // OLD
        // const paymentLatest = item?.evidence.sort((a, b) => {
        //   return a.paid_date > b.paid_date ? 1 : -1;
        // })[item?.evidence.length - 1];

        // const paymentLatestFormat = getCurrentLocalDateTime(
        //   new Date(paymentLatest?.paid_date)
        // ).fullDate;
        // if (
        //   paymentLatestFormat <= `${Number(buroYear.value) - 1}-12-31` &&
        //   item.loan_status === "DONE"
        // ) {
        //   newMapBuroYearDone.push(item);
        //   return null;
        // }
        // return sameObj;

        // NEW
        const paymentLatest = item?.evidence.sort((a, b) => {
          return a.paid_date > b.paid_date ? 1 : -1;
        })[item?.evidence.length - 1];

        const paymentLatestFormat = getCurrentLocalDateTime(
          new Date(paymentLatest?.paid_date)
        ).fullDate;
        const paymentLatestFormatYear = getCurrentLocalDateTime(
          new Date(paymentLatest?.paid_date)
        ).year;

        // console.log("paymentLatestFormat", paymentLatestFormat);
        // console.log("item", item);

        const checkYear =
          item.loan_status === "ACTIVE" ||
          (item.loan_status === "DONE" &&
            Number(paymentLatestFormatYear) > Number(buroYear?.value)) ||
          (item.loan_status === "DONE" &&
            Number(paymentLatestFormatYear) === Number(buroYear?.value));
        //  ||
        // (item.loan_status === "DONE" &&
        //   Number(paymentLatestFormatYear) === Number(buroYear?.value) );

        // const checkPrev =
        //   item?.loan_status === "ACTIVE" ||
        //   (item?.loan_status !== "DONE" &&
        //     Number(paymentLatestFormatYear) <= Number(buroYear?.value - 1));

        if (
          checkYear
          //  ||
          // checkPrev
          // (item?.evidence?.length > 0 &&
          //   paymentLatestFormat <= `${Number(buroYear?.value) - 1}-12-31` &&
          //   item?.loan_status === "ACTIVE") ||
          // item?.loan_status === "ACTIVE"
        ) {
          return sameObj;
        }
        // if (
        //   (paymentLatestFormat <= `${Number(buroYear.value) - 1}-12-31` &&
        //     item.loan_status === "DONE") ||
        //   item.loan_status === "ACTIVE"
        // ) {
        //   // newMapBuroYearDone.push(item);
        //   return sameObj;
        // }
        return null;

        // if (item?.loan_status === "DONE" || item?.loan_status === "ACTIVE") {
        //   return sameObj;
        // }
      })
      .filter((item) => item)
      .filter(
        (item) =>
          item?.requestTimeFullDate <= `${Number(buroYear?.value)}-12-31`
      )
      .sort((a, b) => {
        return Number(a?.loan_kbank_id) > Number(b?.loan_kbank_id) ? 1 : -1;
      });
    return newMapBuroYear;
  };

  const onClickFixedBuroAll = async () => {
    try {
      setLoadingFixedBuro(true);

      const newLoans = [];

      for (const thisLoan of loan) {
        newLoans.push({ ...thisLoan });
        // if (
        //   thisLoan?.evidence?.length > 0 &&
        //   thisLoan.loan_status === "ACTIVE"
        // ) {
        //   const checkEvidence = thisLoan.evidence.some((thisEvidence) => {
        //     const [date, time] = thisEvidence?.paid_date?.split("T");
        //     if (date === "2022-10-31") {
        //       return true;
        //     }
        //   });
        //   if (checkEvidence) {
        //     newLoans.push({ ...thisLoan, localStatus: "ACTIVE" });
        //   }
        // }
      }
      setFixedBuro(getFilterLoanBuro(newLoans, buroDate, interest));
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingFixedBuro(false);
    }
  };

  const onClickFixedBuro = async () => {
    try {
      setLoadingFixedBuro(true);

      let rows = fixedBuro042024.split("\n");
      // rows = rows.slice(0, 1);

      const ids = [];
      let fixedBuroList = [];
      for (let index = 0; index < rows.length; index++) {
        const splitIds = rows[index].split(",");
        const id = splitIds[3];
        if (id) {
          ids.push(id.replace(/"/g, ""));
        }
      }

      console.log("ids", ids);

      let buro_loans = fixedBuro042024.split("\n");
      let defaultBuroList = [];
      for (let index = 0; index < buro_loans.length; index++) {
        const splitDots = buro_loans[index].split(",");
        const newData = splitDots.map((dot) => {
          return dot.replace(/"/g, "");
        });
        defaultBuroList = [...defaultBuroList, newData];
      }
      // for (let index = 0; index < buro_loans.length; index++) {
      //   const splitDots = buro_loans[index].split(",");
      //   const newData = splitDots.map(dot => {
      //     return dot.replace(/"/g, "")
      //   })
      //   defaultBuroList = [...defaultBuroList, newData]
      // }

      for (const id of ids) {
        const data = await API.get("MoneyHubAdmin", "/buro/single", {
          queryStringParameters: {
            field_name: "loan_kbank_id",
            value: id,
          },
        });
        fixedBuroList.push(data.loan);
      }

      setFixedBuro(_.cloneDeep(prePareLoan(fixedBuroList)));
      setDefaultBuro(_.cloneDeep(defaultBuroList));
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingFixedBuro(false);
    }
  };

  const onClickFetchBuroYear = async (type) => {
    try {
      setLoadingBuroYear(true);
      let datas = {};
      let count = 0;
      let lastItem = null;
      let allItems = [];
      let fullDate = getCurrentLocalDateTime().fullDate;

      do {
        if (type === "single") {
          datas = await API.get(
            "MoneyHubAdmin",
            `/loan/sandbox/loankbank/${jobNo}`,
            {
              queryStringParameters: {
                Limit: 50,
                countData: 1,
                paid_date: fullDate,
                package: "All",
                status: "ACTIVE",
                overDueDate: fullDate,
                letter: "All",
                SELECT_ALL: true,
                min_created:
                  String(buroYear.value) === "2022"
                    ? `2021-10-05`
                    : `${buroYear.value}-01-01`,
                max_created: `${buroYear?.value}-12-31`,
                request_id: jobNo,
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            }
          );
          allItems = [...allItems, datas?.loan];
          lastItem = datas?.lastItem;
          setCountBuroYear(allItems.length);
        } else {
          const monthEndDate = getBuroMonthEndDate(
            moment(monthYear, "YYYY-MM", true)
          );

          datas = await API.get(
            "MoneyHubAdmin",
            `/loan/sandbox/buroAgingReport`,
            {
              queryStringParameters: {
                paid_date: monthEndDate, // MAX
                // min_date:
                //   String(buroYear?.value) === "2022"
                //     ? `2021-10-05`
                //     : `${buroYear?.value}-01-01`,
                min_date: `${monthYear}-01`,
                // FilterExpression: "",
                ExclusiveStartKey: getLastItem(lastItem),
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            }
          );
          allItems = [...allItems, ...datas?.Items];
          lastItem = datas?.lastItem;
          setCountBuroYear(allItems.length);
        }
      } while (lastItem);

      // console.log("allItems", allItems);
      const newAllItems = mapBuroYear(allItems);
      setBuroYearItems(newAllItems);
      setBuroYearChunckItems(getChunckItems(newAllItems, countLength));
    } catch (error) {
      setErrorBuroYear(error);
      alert(error);
    } finally {
      setLoadingBuroYear(false);
    }
  };

  const nextTimeOut = () => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, 3000);
    });
  };

  const onClickSendEmail = async () => {
    try {
      setLoadingEmail(true);
      const emailLoans =
        buroYearItems?.length === 1
          ? buroYearItems
          : newFilterBuroChunck.chunckItems[chunckActiveIndex];
      // ?.filter((item) => item?.letter === "1");

      setCountEmail(emailLoans?.length);

      console.log("emailLoans", emailLoans);

      let index = 0;
      let countSuccess = 0;
      for (const emailLoan of emailLoans) {
        const merger = new PDFMerger();
        let blobYear = await pdf(
          <PdfBuroYear
            interest={interest}
            buroYear={buroYear}
            data={emailLoan}
          />
        ).toBlob();

        // let blobDetail = await Storage.get(`รหัสและสถานะบัญชี.pdf`, {
        //   download: true,
        // });

        // let fileDetail = new File([blobDetail.Body], `รหัสและสถานะบัญชี.pdf`, {
        //   type: "pdf",
        // });

        await merger.add(blobYear);
        // await merger.add(fileDetail);

        const blobMerger = await merger.saveAsBuffer();
        const mz = new Minizip();
        const splitBirthDay = emailLoan.birthdateTh.split("/");
        let password = "";
        if (splitBirthDay?.length === 3) {
          const fulldate = `${splitBirthDay[2]}-${pad(splitBirthDay[1])}-${pad(
            splitBirthDay[0]
          )}`;
          password = format(new Date(fulldate), "ddMMyyyy");
        }
        const fileNameSuffix = `${format(new Date(), "dd-MM-yyyy")}`;
        let filename = `LOAN_BURO_YEAR_${emailLoan.loan_kbank_id}_${fileNameSuffix}.pdf`;
        const filenameZip = `LOAN_BURO_YEAR_${emailLoan?.loan_kbank_id}_${fileNameSuffix}.zip`;
        mz.append(filename, blobMerger, { password });
        const fileMerger = new File([mz.zip()], filenameZip, {
          type: "application/x-zip-compressed",
        });
        await Storage.put(filenameZip, fileMerger);
        const url = await Storage.get(filenameZip);
        await API.post("MoneyHubAdmin", `/loan/sendEmail`, {
          body: {
            subject: `แจ้งการนำส่งข้อมูลรายปี ตามข้อตกลง บริษัทข้อมูลเครดิต แห่งชาติ จำกัด อ้างอิงสัญญาเลขที่ ${emailLoan.loan_kbank_id}`,
            filename: filenameZip,
            path: url,
            email: emailLoan?.email,
            loan_id: emailLoan?.loan_id,
            request_id: emailLoan?.request_id,
            reference_id: emailLoan?.loan_kbank_id,
            birthdateTh: emailLoan?.birthdateTh,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        await nextTimeOut();
        countSuccess++;
        console.log("NEXT STATION");
        index++;
      }
      await EmitterStatus("SUCCESS", {
        text: `T:${emailLoans?.length} S:${countSuccess} F:0`,
      });
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingEmail(false);
    }
  };

  const filterBuroChunck = () => {
    let newBuroYear = [];
    let countBuroYear = 0;
    for (const buroYearChunckItem of buroYearChunckItems) {
      for (const buroYear of buroYearChunckItem) {
        if (selectYearFilter?.value === buroYear?.letter) {
          newBuroYear.push(buroYear);
          countBuroYear++;
        }
      }
    }
    return {
      chunckItems: getChunckItems(newBuroYear, countLength),
      countBuroYear,
    };
  };

  const newFilterBuroChunck = useMemo(() => {
    return filterBuroChunck();
  }, [
    buroYearItems,
    selectYearFilter,
    buroYearChunckItems,
    buroYear,
    chunckActiveIndex,
  ]);

  const onClickSendLetter = async () => {
    try {
      setLoadingLetter(true);
      const letterLoans =
        buroYearItems.length === 1
          ? buroYearItems
          : newFilterBuroChunck.chunckItems[chunckActiveIndex];
      // ? buroYearItems?.filter((item) => item?.letter === "2")
      // : buroYearChunckItems[chunckActiveIndex]?.filter(
      //     (item) => item?.letter === "2"
      //   );

      setCountLetter(letterLoans?.length);

      const filename = `EXPORT_LETTER_BURO_YEAR_${buroYear?.value}`;
      const merger = new PDFMerger();
      let index = 0;

      // let blobStatusDetail = await Storage.get(`รหัสและสถานะบัญชี.pdf`, {
      //   download: true,
      // });

      // let fileStatusDetail = new File(
      //   [blobStatusDetail.Body],
      //   `รหัสและสถานะบัญชี.pdf`,
      //   {
      //     type: "pdf",
      //   }
      // );

      for (const letterLoan of letterLoans) {
        let blobYear = await pdf(
          <PdfBuroYear
            interest={interest}
            buroYear={buroYear}
            data={letterLoan}
          />
        ).toBlob();

        await merger.add(blobYear);
        // await merger.add(fileStatusDetail);
        index++;
      }
      await merger.save(filename);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingLetter(false);
    }
  };

  const onChangeSelectBuroYear = (e) => {
    setSelectYearFilter(e);
    setChunckActiveIndex(-1);
  };

  if (loadingInterest) {
    return (
      <ContainerContent>
        <LoadingPage />
      </ContainerContent>
    );
  }

  return (
    <ContainerContent>
      <Tabs>
        <Tab
          tab={tab}
          setTab={setTab}
          tabValue="M"
          name="Manage"
          icon={IconDashboard}
        />
        <Tab
          tab={tab}
          setTab={setTab}
          tabValue="B"
          name="Buro Ban"
          icon={IconList}
        />
      </Tabs>

      {tab === "M" && (
        <div className="ml-4 mt-8">
          <div className="flex items-center mb-6 space-x-3">
            <Radio
              name="manage"
              label="Multiple"
              value={"M"}
              selectRadio={manageStatus}
              onChange={onChangeManageStatus}
            />
            <Radio
              name="manage"
              label="Single"
              value={"S"}
              selectRadio={manageStatus}
              onChange={onChangeManageStatus}
            />
            <Radio
              name="Year"
              label="Buro Year"
              value={"Y"}
              selectRadio={manageStatus}
              onChange={onChangeManageStatus}
            />
          </div>

          {manageStatus === "M" && (
            <React.Fragment>
              <div className=" mb-4 flex space-x-2">
                <Button onClick={onClickToday}>Today</Button>
                <Button onClick={onClickMonth}>Month</Button>
                <Button onClick={onClickStartToday}>Start - Today</Button>
              </div>
              <div className="flex flex-row space-x-6">
                <div className="flex items-center space-x-6">
                  <Input
                    onChange={onChangeRequestTime}
                    value={dateRequestTime.min}
                    label="วันที่สร้าง - เริ่ม"
                    name="min"
                    type="date"
                  />
                  <Input
                    onChange={onChangeRequestTime}
                    value={dateRequestTime.max}
                    label="วันที่สร้าง - สิ้นสุด"
                    name="max"
                    type="date"
                  />
                </div>
                <div className="flex">
                  <div className="flex flex-col items-start">
                    <label htmlFor="buro-month-multiple">วันที่ส่งบูโร</label>
                    <DatePicker
                      id="buro-month-multiple"
                      picker="month"
                      format="YYYY-MM"
                      value={moment(buroDate, "YYYY-MM-DD", true)}
                      onChange={onChangeBuroMonth}
                      allowClear={false}
                      size="large"
                      className="rounded-lg"
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-row space-x-6 mt-4 w-full items-center">
                {/* <Input
                  onChange={onChangeAgingDate}
                  value={agingDate}
                  label="วันที่"
                  name="agingDate"
                  type="date"
                /> */}
                <div className=" mt-auto flex space-x-3">
                  <Aging
                    loan={loan}
                    setLoan={setLoan}
                    setOriLoan={setOriLoan}
                    agingDate={agingDate}
                    setIsSelectAll={setIsSelectAll}
                    setCount={setCount}
                    count={count}
                    setDisabledAging={setDisabledAging}
                    disabledAging={disabledAging}
                    disabledLastPayment={disabledLastPayment}
                    setDisabledLastPayment={setDisabledLastPayment}
                    setLoanNotCal={setLoanNotCal}
                    buroDate={buroDate}
                    dateRequestTime={dateRequestTime}
                  />
                  <LastPaymentDone
                    setLoanLastPaymentDone={setLoanLastPaymentDone}
                    loan={loan}
                    setLoan={setLoan}
                    setOriLoan={setOriLoan}
                    agingDate={agingDate}
                    setIsSelectAll={setIsSelectAll}
                    setCount={setCount}
                    count={count}
                    setDisabledAging={setDisabledAging}
                    disabledAging={disabledAging}
                    disabledLastPayment={disabledLastPayment}
                    setDisabledLastPayment={setDisabledLastPayment}
                    setLoanNotCal={setLoanNotCal}
                    buroDate={buroDate}
                  />
                  {/* <Button
                    loading={loadingFixedBuro}
                    disabled={loadingFixedBuro}
                    onClick={onClickFixedBuroAll}
                  >
                    Buro10 (ALL)
                  </Button> */}
                  <Button
                    loading={loadingFixedBuro}
                    disabled={loadingFixedBuro}
                    onClick={onClickFixedBuro}
                  >
                    Buro042024 (183 + 7)
                  </Button>
                  <ExportFixedBuro
                    loan={fixedBuro}
                    buroDate={`${buroDate}`}
                    interest={interest}
                    defaultBuroList={defaultBuro}
                  />
                </div>
              </div>
              <div className="mt-4 flex space-x-2">
                {/* <Button
                  loading={loadingGenFile}
                  onClick={onClickGenFile}
                  color="green"
                  disabled={disabledAging || disabledLastPayment}
                >
                  <div className="flex flex-row space-x-2">
                    {loadingGenFile && <div>{count}</div>}
                    <div>ยืนยัน</div>
                  </div>
                </Button> */}
                {oriLoan.length > 0 && (
                  <ExportBuro
                    interest={interest}
                    loan={oriLoanChecked}
                    buroDate={buroDate}
                    loanLastPaymentDone={loanLastPaymentDone}
                  />
                )}
                {oriLoan.length > 0 && (
                  <ExportFirstYearBuro
                    loan={oriLoanChecked}
                    buroDate={buroDate}
                  />
                )}
                {/* {oriLoan.length > 0 && (
                  <UpdateBuro
                    interest={interest}
                    loan={oriLoanChecked}
                    buroDate={buroDate}
                  />
                )} */}
                {oriLoan.length > 0 && (
                  <LetterBuro
                    interest={interest}
                    loan={oriLoanChecked}
                    buroDate={buroDate}
                  />
                )}
                {oriLoan.length > 0 && (
                  <SendEmail
                    loan={oriLoanChecked}
                    buroDate={buroDate}
                    interest={interest}
                    loanLastPaymentDone={loanLastPaymentDone}
                  />
                )}
                {oriLoan.length > 0 && <Envelope loan={oriLoanChecked} />}
                {oriLoan.length > 0 && (
                  <ExportPLC
                    loan={oriLoanChecked}
                    buroDate={buroDate}
                    interest={interest}
                  />
                )}
                {oriLoan.length > 0 && (
                  <ExportPLO
                    loan={oriLoanChecked}
                    buroDate={buroDate}
                    interest={interest}
                  />
                )}
                {oriLoan.length > 0 && (
                  <ReportNCB
                    loan={oriLoanChecked}
                    buroDate={buroDate}
                    loanNotCal={loanNotCal}
                    interest={interest}
                    loanLastPaymentDone={loanLastPaymentDone}
                  />
                )}
                {oriLoan.length > 0 && (
                  <ReportBotPLO
                    loan={oriLoanChecked}
                    buroDate={buroDate}
                    interest={interest}
                  />
                )}
                {oriLoan.length > 0 && (
                  <ReportBotPLC
                    loan={oriLoanChecked}
                    buroDate={buroDate}
                    interest={interest}
                  />
                )}
              </div>
              {oriLoan.length > 0 && (
                <div className=" flex mt-4 space-x-3 text-sm">
                  <div>จำนวน {count}</div>
                  <div>เลือก {loan.filter((item) => item.checked)?.length}</div>
                </div>
              )}
              {oriLoan.length > 0 && (
                <div className="mt-4 flex space-x-2">
                  <Input
                    type="text"
                    placeholder="Search Job no / Name"
                    onChange={onChangeSearch}
                  />
                  <FilterEmail
                    oriLoan={oriLoan}
                    setLoan={setLoan}
                    selectOption={selectOption}
                    setSelectOption={setSelectOption}
                  />
                </div>
              )}

              <div className=" mt-4">
                {loan.length > 0 && (
                  <div className=" mb-4 inline-block">
                    {isSelectAll ? (
                      <div
                        onClick={onClickUnSelectAll}
                        className=" text-blue-500  cursor-pointer"
                      >
                        Unselect All
                      </div>
                    ) : (
                      <div
                        onClick={onClickSelectAll}
                        className=" text-blue-500 cursor-pointer "
                      >
                        Select All
                      </div>
                    )}
                  </div>
                )}

                <div className="grid grid-cols-4 gap-6">
                  {loan.length > 0 &&
                    !loadingGenFile &&
                    loan.slice(0, skip).map((item) => {
                      return (
                        <Card
                          key={item.loan_id}
                          buroDate={buroDate}
                          loan={item}
                          setLoan={setLoan}
                          setOriLoan={setOriLoan}
                        />
                      );
                    })}
                </div>
                {loan.length > 0 && !loadingGenFile && loan.length > limit && (
                  <div className="flex items-center w-full justify-center mt-4">
                    <Button
                      disabled={loadingMore}
                      loading={loadingMore}
                      onClick={onClickSkip}
                      color="blue"
                    >
                      ดูเพิ่มเติม
                    </Button>
                  </div>
                )}
              </div>
            </React.Fragment>
          )}

          {manageStatus === "S" && (
            <React.Fragment>
              <div className="flex items-center mt-4 mb-6 space-x-3">
                <Radio
                  name="field_name"
                  label="Job no"
                  value={"loan_kbank_id"}
                  selectRadio={radioFieldName}
                  onChange={onChangeRadioFieldName}
                />
                <Radio
                  name="field_name"
                  label="Name"
                  value={"name"}
                  selectRadio={radioFieldName}
                  onChange={onChangeRadioFieldName}
                />
              </div>
              <div className=" mb-4">
                <div className="flex flex-col items-start">
                  <label htmlFor="buro-month-single">วันที่ส่งบูโร</label>
                  <DatePicker
                    id="buro-month-single"
                    picker="month"
                    format="YYYY-MM"
                    value={moment(buroDate, "YYYY-MM-DD", true)}
                    onChange={onChangeBuroMonth}
                    allowClear={false}
                    size="large"
                    className="rounded-lg"
                  />
                </div>
              </div>
              <div className="flex space-x-3 items-center">
                <Input
                  type="text"
                  placeholder="Search Job no / Name"
                  onChange={onChangeSearchSingle}
                  value={searched}
                />
                <Button
                  disabled={loadingSingle}
                  loading={loadingSingle}
                  onClick={onClickLoadSingle}
                >
                  Submit
                </Button>
                {oriSingleLoad.length > 0 && (
                  <ExportBuro
                    interest={interest}
                    loan={oriSingleLoanChecked}
                    buroDate={buroDate}
                    loanLastPaymentDone={loanLastPaymentDone}
                  />
                )}
                {oriSingleLoad.length > 0 && (
                  <div className="w-30">
                    <LastPaymentDone
                      setLoanLastPaymentDone={setLoanLastPaymentDone}
                      loan={oriSingleLoanChecked}
                      setLoan={setOriSingleLoad}
                      setOriLoan={setOriLoan}
                      agingDate={agingDate}
                      setIsSelectAll={setIsSelectAll}
                      setCount={setCount}
                      count={count}
                      setDisabledAging={setDisabledAging}
                      disabledAging={disabledAging}
                      disabledLastPayment={disabledLastPayment}
                      setDisabledLastPayment={setDisabledLastPayment}
                      setLoanNotCal={setLoanNotCal}
                      buroDate={buroDate}
                    />
                  </div>
                )}
                {oriSingleLoad.length > 0 && (
                  <ExportBuroSelected
                    interest={interest}
                    loan={oriSingleLoanChecked}
                    buroDate={buroDate}
                    loanLastPaymentDone={[]}
                  />
                )}
                {/* {oriSingleLoad.length > 0 && (
                  <UpdateBuro
                    interest={interest}
                    loan={oriSingleLoanChecked}
                    buroDate={buroDate}
                  />
                )} */}
                {oriSingleLoad.length > 0 && (
                  <ExportPLC loan={oriSingleLoanChecked} buroDate={buroDate} />
                )}
                {oriSingleLoad.length > 0 && (
                  <ExportPLO loan={oriSingleLoanChecked} buroDate={buroDate} />
                )}
                {oriSingleLoad.length > 0 && (
                  <ReportNCB
                    loan={oriSingleLoanChecked}
                    buroDate={buroDate}
                    loanNotCal={loanNotCal}
                    interest={interest}
                  />
                )}
                {oriSingleLoad.length > 0 && (
                  <LetterBuro
                    interest={interest}
                    loan={oriSingleLoanChecked}
                    buroDate={buroDate}
                  />
                )}
                {oriSingleLoad.length > 0 && (
                  <SendEmail
                    loan={oriSingleLoanChecked}
                    buroDate={buroDate}
                    interest={interest}
                  />
                )}
                {oriSingleLoad.length > 0 && (
                  <Envelope loan={oriSingleLoanChecked} />
                )}
                {oriSingleLoad.length > 0 && (
                  <ReportBotPLO
                    loan={oriSingleLoanChecked}
                    buroDate={buroDate}
                  />
                )}
                {oriSingleLoad.length > 0 && (
                  <ReportBotPLC
                    loan={oriSingleLoanChecked}
                    buroDate={buroDate}
                  />
                )}
                {/* {oriSingleLoad.length > 0 && (
                  <ExportPLC loan={oriSingleLoanChecked} buroDate={buroDate} />
                )}
                {oriSingleLoad.length > 0 && (
                  <ExportPLO loan={oriSingleLoanChecked} buroDate={buroDate} />
                )} */}
              </div>

              {singleLoad.length > 0 && (
                <div className="flex mt-2">
                  <div className=" flex space-x-3 text-sm">
                    <div>จำนวน {oriSingleLoad.length}</div>
                    <div>
                      เลือก {singleLoad.filter((item) => item.checked)?.length}
                    </div>
                  </div>
                </div>
              )}

              {singleLoad.length > 0 && (
                <div className=" mt-4 mb-4 inline-block">
                  {isSingleSelectAll ? (
                    <div
                      onClick={onClickSingleUnSelectAll}
                      className=" text-blue-500  cursor-pointer"
                    >
                      Unselect All
                    </div>
                  ) : (
                    <div
                      onClick={onClickSingleSelectAll}
                      className=" text-blue-500 cursor-pointer "
                    >
                      Select All
                    </div>
                  )}
                </div>
              )}

              <div className="grid grid-cols-4 gap-6 ">
                {singleLoad.length > 0 &&
                  singleLoad.slice(0, skip).map((item) => {
                    return (
                      <Card
                        key={item.loan_id}
                        buroDate={buroDate}
                        loan={item}
                        setLoan={setSingleLoad}
                        setOriLoan={setOriSingleLoad}
                      />
                    );
                  })}
              </div>
            </React.Fragment>
          )}

          {manageStatus === "Y" && (
            <div className="">
              <div className="flex items-center space-x-2 mb-2">
                <div>Job No.</div>
                <Input
                  value={jobNo}
                  onChange={(e) => setJobNo(e.target.value)}
                />
                <Button
                  loading={loadingBuroYear}
                  disabled={loadingBuroYear}
                  onClick={() => onClickFetchBuroYear("single")}
                  className="ml-4"
                >
                  ยืนยัน
                </Button>
              </div>
              <div className="flex items-center space-x-2">
                <div className="flex items-center space-x-2">
                  <label htmlFor="buro-month-year">เดือน</label>
                  <DatePicker
                    id="buro-month-year"
                    picker="month"
                    format="YYYY-MM"
                    value={moment(monthYear, "YYYY-MM", true)}
                    onChange={onChangeBuroYearMonth}
                    allowClear={false}
                    size="large"
                    className="rounded-lg"
                  />
                </div>
                <div>เลือกปี</div>
                <Select
                  className="w-40"
                  onChange={(e) => setBuroYear(e)}
                  value={buroYear}
                  // onChange={(e) => setYear(e)}
                  // value={year}
                  options={getYears()}
                />
                <Button
                  loading={loadingBuroYear}
                  disabled={loadingBuroYear}
                  onClick={() => onClickFetchBuroYear("multiple")}
                  className="ml-4"
                >
                  {countBuroYear} ยืนยัน
                </Button>
              </div>
              <div className="flex items-center space-x-2 mt-2">
                <div>อีเมล/ส่งจดหมาย</div>
                <Select
                  className="w-40"
                  onChange={onChangeSelectBuroYear}
                  value={selectYearFilter}
                  options={[
                    { label: "อีเมล", value: "1" },
                    { label: "ส่งจดหมาย", value: "2" },
                  ]}
                />
              </div>

              <div className="flex items-center space-x-2 mt-2 mb-2">
                {buroYearItems.length > 0 && (
                  <React.Fragment>
                    <Button
                      loading={loadingEmail}
                      disabled={
                        loadingEmail ||
                        (chunckActiveIndex === -1 &&
                          buroYearItems?.length === 0)
                      }
                      onClick={onClickSendEmail}
                      className="ml-4"
                    >
                      {countEmail} ส่งอีเมล (ทั้งหมด)
                    </Button>
                    <Envelope
                      customDisabled={
                        chunckActiveIndex === -1 && buroYearItems.length > 1
                      }
                      loan={
                        buroYearItems.length === 1
                          ? buroYearItems
                          : newFilterBuroChunck.chunckItems[chunckActiveIndex]
                      }
                    />
                    <Button
                      loading={loadingLetter}
                      disabled={
                        loadingLetter ||
                        (chunckActiveIndex === -1 && buroYearItems.length > 1)
                      }
                      onClick={onClickSendLetter}
                      className="ml-4"
                    >
                      ส่งจดหมายรายปี
                    </Button>
                    <ExportFirstYearBuro
                      loan={
                        buroYearItems.length === 1
                          ? buroYearItems
                          : newFilterBuroChunck.chunckItems[chunckActiveIndex]
                      }
                      customDisabled={
                        chunckActiveIndex === -1 && buroYearItems.length > 1
                      }
                      buroDate={`${buroYear?.value}-12-31`}
                      label="(ทั้งหมด)"
                    />
                  </React.Fragment>
                )}
              </div>

              <div>จำนวน {newFilterBuroChunck?.countBuroYear}</div>

              {buroYearItems?.length === 1 && (
                <PDFViewer width={900} height={1100}>
                  <PdfBuroYear
                    s3Status={s3Status}
                    interest={interest}
                    buroYear={buroYear}
                    data={buroYearItems[0]}
                  />
                </PDFViewer>
              )}

              {buroYearItems?.length > 1 && (
                <div className="mt-2 grid grid-cols-10 items-center">
                  {newFilterBuroChunck?.chunckItems?.map((item, index) => {
                    return (
                      <div
                        index={index}
                        onClick={() => onClickChunckItem(index)}
                        className={classNames(
                          "px-2 py-4 cursor-pointer ml-1 mr-1 mt-2 text-center text-white",
                          {
                            "bg-blue-500": index === chunckActiveIndex,
                            "bg-gray-300": index !== chunckActiveIndex,
                          }
                        )}
                      >
                        {index + 1 ===
                        newFilterBuroChunck?.chunckItems?.length ? (
                          newFilterBuroChunck?.chunckItems?.[
                            newFilterBuroChunck?.chunckItems?.length - 1
                          ]?.length
                        ) : (
                          <div>
                            {" "}
                            {index * countLength + 1} -{" "}
                            {(index + 1) * countLength}
                          </div>
                        )}

                        {/* {index + 1 === newFilterBuroChunck?.length
                          ? newFilterBuroChunck[newFilterBuroChunck?.length - 1]
                              ?.length
                          : (index + 1) * countLength} */}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      )}
      {tab === "B" && (
        <div className="ml-4 mt-8">
          <Input
            onChange={(e) => {
              setLoan_kbank_id(e.target.value);
            }}
            value={loan_kbank_id}
            label="Ref"
            type="text"
          />
          {notFound && (
            <div className=" text-sm text-red-400 ml-2 ">
              ไม่พบข้อมูลนี้ในระบบ
            </div>
          )}
          <div className=" mt-2"></div>
          <Button loading={loadingBuroBan} onClick={onClickBuroBan}>
            ยืนยัน
          </Button>
          {loadingQueryBuroBan ? (
            <ContainerContent>
              <LoadingPage />
            </ContainerContent>
          ) : (
            <div className="grid grid-cols-4 gap-6 mt-4">
              {buroBan?.length > 0 &&
                buroBan.map((ban) => {
                  return (
                    <CardBuroBan
                      fetchBuroBan={fetchBuroBan}
                      key={ban}
                      loan={ban}
                    />
                  );
                })}
            </div>
          )}
        </div>
      )}
      {/* {tab === "H" && (
        <div className="ml-4 mt-8">
          <HistoryFile />
        </div>
      )} */}
    </ContainerContent>
  );
};
